export default __webpack_public_path__ + "static/media/gallary7.5172340a.jpg";